export const isParserError = e => 'object' == typeof e && null !== e && 'errid' in e
export const splitMediaQueryList = e => {
	const t = [[]],
		r = []
	for (const n of e)
		if ('comma' === n.type && 0 === r.length) t.push([])
		else {
			switch (n.type) {
				case 'function':
				case '(':
					r.push(')')
					break
				case '[':
					r.push(']')
					break
				case '{':
					r.push('}')
					break
				case ')':
				case ']':
				case '}':
					r.at(-1) === n.type && r.pop()
					break
			}
			t[t.length - 1].push(n)
		}
	return t
}
export const readMediaQueryList = e => {
	const t = splitMediaQueryList(e)
	if (1 === t.length && 0 === t[0].length)
		return {type: 'query-list', mediaQueries: [{type: 'query'}]}
	{
		const e = []
		for (const r of t) {
			const t = readMediaQuery(r)
			isParserError(t) ? e.push({type: 'query', prefix: 'not'}) : e.push(t)
		}
		return {type: 'query-list', mediaQueries: e}
	}
}
export const readMediaQuery = e => {
	var t, r, n
	const i = e.at(0)
	if (i) {
		if ('(' === i.type) {
			const r = readMediaCondition(e, !0)
			if (isParserError(r)) {
				const {start: n, end: a} = null !== (t = e.at(1)) && void 0 !== t ? t : i
				return {errid: 'EXPECT_FEATURE_OR_CONDITION', start: n, end: a, child: r}
			}
			return {type: 'query', mediaCondition: r}
		}
		if ('ident' === i.type) {
			let t, a
			const {value: d, end: s} = i
			;('only' !== d && 'not' !== d) || (t = d)
			const o = void 0 === t ? 0 : 1,
				l = e.at(o)
			if (!l) return {errid: 'EXPECT_LPAREN_OR_TYPE', start: s, end: s}
			if ('ident' !== l.type) {
				if ('not' === t && '(' === l.type) {
					const t = readMediaCondition(e.slice(o), !0)
					if (isParserError(t)) {
						const {start: n, end: i} = null !== (r = e.at(o + 1)) && void 0 !== r ? r : l
						return {errid: 'EXPECT_CONDITION', start: n, end: i, child: t}
					}
					return {
						type: 'query',
						mediaCondition: {type: 'condition', operator: 'not', children: [t]}
					}
				}
				{
					const {start: e, end: t} = l
					return {errid: 'EXPECT_TYPE', start: e, end: t}
				}
			}
			{
				const {value: e, start: r, end: n} = l
				if ('all' === e) a = void 0
				else if ('print' === e || 'screen' === e) a = e
				else {
					if (
						'tty' !== e &&
						'tv' !== e &&
						'projection' !== e &&
						'handheld' !== e &&
						'braille' !== e &&
						'embossed' !== e &&
						'aural' !== e &&
						'speech' !== e
					)
						return {errid: 'EXPECT_TYPE', start: r, end: n}
					;(t = 'not' === t ? void 0 : 'not'), (a = void 0)
				}
			}
			if (o + 1 === e.length) return {type: 'query', prefix: t, mediaType: a}
			{
				const r = e[o + 1]
				if ('ident' === r.type && 'and' === r.value) {
					const r = e.at(-1),
						i = e.at(o + 2)
					let d,
						s = r.end + 1
					if ('ident' === (null == i ? void 0 : i.type) && 'not' === i.value) {
						s += 1
						const t = readMediaCondition(e.slice(o + 3), !1)
						d = isParserError(t) ? t : {type: 'condition', operator: 'not', children: [t]}
					} else d = readMediaCondition(e.slice(o + 2), !1)
					const {start: l, end: u} =
						null !== (n = e.at(o + 2)) && void 0 !== n ? n : {start: s, end: s}
					return isParserError(d)
						? {errid: 'EXPECT_CONDITION', start: l, end: u, child: d}
						: {type: 'query', prefix: t, mediaType: a, mediaCondition: d}
				}
				return {errid: 'EXPECT_AND', start: r.start, end: r.end}
			}
		}
		return {errid: 'EXPECT_LPAREN_OR_TYPE_OR_MODIFIER', start: i.start, end: i.end}
	}
	return {errid: 'EMPTY_QUERY', start: 0, end: 0}
}
export const readMediaCondition = (e, t, r) => {
	const n = e.at(0)
	if (n) {
		if ('(' !== n.type) return {errid: 'EXPECT_LPAREN', start: n.start, end: n.end}
		let i,
			a = e.length - 1,
			d = 0,
			s = 0
		for (const [t, r] of e.entries())
			if (
				('(' === r.type ? ((s += 1), (d = Math.max(d, s))) : ')' === r.type && (s -= 1), 0 === s)
			) {
				a = t
				break
			}
		if (0 !== s) return {errid: 'MISMATCH_PARENS', start: n.start, end: e[e.length - 1].end}
		const o = e.slice(0, a + 1)
		if (
			((i =
				1 === d
					? readMediaFeature(o)
					: 'ident' === o[1].type && 'not' === o[1].value
					? readMediaCondition(o.slice(2, -1), !0, 'not')
					: readMediaCondition(o.slice(1, -1), !0)),
			isParserError(i))
		)
			return {
				errid: 'EXPECT_FEATURE_OR_CONDITION',
				start: n.start,
				end: o[o.length - 1].end,
				child: i
			}
		if (a === e.length - 1) return {type: 'condition', operator: r, children: [i]}
		{
			const n = e[a + 1]
			if ('ident' !== n.type || ('and' !== n.value && 'or' !== n.value))
				return {errid: 'EXPECT_AND_OR_OR', start: n.start, end: n.end}
			if (void 0 !== r && r !== n.value)
				return {errid: 'MIX_AND_WITH_OR', start: n.start, end: n.end}
			if ('or' === n.value && !t) return {errid: 'MIX_AND_WITH_OR', start: n.start, end: n.end}
			const d = readMediaCondition(e.slice(a + 2), t, n.value)
			return isParserError(d)
				? d
				: {type: 'condition', operator: n.value, children: [i, ...d.children]}
		}
	}
	return {errid: 'EMPTY_CONDITION', start: 0, end: 0}
}
export const readMediaFeature = e => {
	const t = e.at(0)
	if (t) {
		if ('(' !== t.type) return {errid: 'EXPECT_LPAREN', start: t.start, end: t.end}
		const r = e[e.length - 1]
		if (')' !== r.type) return {errid: 'EXPECT_RPAREN', start: r.end + 1, end: r.end + 1}
		const n = [e[0]]
		for (let t = 1; t < e.length; t++) {
			if (t < e.length - 2) {
				const r = e[t],
					i = e[t + 1],
					a = e[t + 2]
				if (
					'number' === r.type &&
					r.value > 0 &&
					'delim' === i.type &&
					47 === i.value &&
					'number' === a.type &&
					a.value > 0
				) {
					n.push({
						type: 'ratio',
						numerator: r.value,
						denominator: a.value,
						hasSpaceBefore: r.hasSpaceBefore,
						hasSpaceAfter: a.hasSpaceAfter,
						start: r.start,
						end: a.end
					}),
						(t += 2)
					continue
				}
			}
			n.push(e[t])
		}
		const i = n[1]
		if ('ident' === i.type && 3 === n.length)
			return {type: 'feature', context: 'boolean', feature: i.value}
		if (5 === n.length && 'ident' === n[1].type && 'colon' === n[2].type) {
			const e = n[3]
			if (
				'number' === e.type ||
				'dimension' === e.type ||
				'ratio' === e.type ||
				'ident' === e.type
			) {
				let t,
					r = n[1].value
				const i = r.slice(0, 4)
				'min-' === i
					? ((t = 'min'), (r = r.slice(4)))
					: 'max-' === i && ((t = 'max'), (r = r.slice(4)))
				const {hasSpaceBefore: a, hasSpaceAfter: d, start: s, end: o, ...l} = e
				return {type: 'feature', context: 'value', prefix: t, feature: r, value: l}
			}
			return {errid: 'EXPECT_VALUE', start: e.start, end: e.end}
		}
		if (n.length >= 5) {
			const e = readRange(n)
			if (isParserError(e))
				return {errid: 'EXPECT_RANGE', start: t.start, end: n[n.length - 1].end, child: e}
			{
				const {feature: t, ...r} = e
				return {type: 'feature', context: 'range', feature: t, range: r}
			}
		}
		return {errid: 'INVALID_FEATURE', start: t.start, end: e[e.length - 1].end}
	}
	return {errid: 'EMPTY_FEATURE', start: 0, end: 0}
}
export const readRange = e => {
	var t, r, n, i, a, d, s, o
	if (e.length < 5)
		return {
			errid: 'INVALID_RANGE',
			start:
				null !== (r = null === (t = e.at(0)) || void 0 === t ? void 0 : t.start) && void 0 !== r
					? r
					: 0,
			end:
				null !== (i = null === (n = e.at(-1)) || void 0 === n ? void 0 : n.end) && void 0 !== i
					? i
					: 0
		}
	if ('(' !== e[0].type) return {errid: 'EXPECT_LPAREN', start: e[0].start, end: e[0].end}
	const l = e[e.length - 1]
	if (')' !== l.type) return {errid: 'EXPECT_RPAREN', start: l.start, end: l.end}
	const u = {feature: ''},
		p =
			'number' === e[1].type ||
			'dimension' === e[1].type ||
			'ratio' === e[1].type ||
			('ident' === e[1].type && 'infinite' === e[1].value)
	if ('delim' === e[2].type) {
		if (60 === e[2].value)
			'delim' !== e[3].type || 61 !== e[3].value || e[3].hasSpaceBefore
				? (u[p ? 'leftOp' : 'rightOp'] = '<')
				: (u[p ? 'leftOp' : 'rightOp'] = '<=')
		else if (62 === e[2].value)
			'delim' !== e[3].type || 61 !== e[3].value || e[3].hasSpaceBefore
				? (u[p ? 'leftOp' : 'rightOp'] = '>')
				: (u[p ? 'leftOp' : 'rightOp'] = '>=')
		else {
			if (61 !== e[2].value) return {errid: 'INVALID_RANGE', start: e[0].start, end: l.end}
			u[p ? 'leftOp' : 'rightOp'] = '='
		}
		if (p) u.leftToken = e[1]
		else {
			if ('ident' !== e[1].type) return {errid: 'INVALID_RANGE', start: e[0].start, end: l.end}
			u.feature = e[1].value
		}
		const t =
				2 +
				(null !==
					(d = null === (a = u[p ? 'leftOp' : 'rightOp']) || void 0 === a ? void 0 : a.length) &&
				void 0 !== d
					? d
					: 0),
			r = e[t]
		if (p) {
			if ('ident' !== r.type) return {errid: 'INVALID_RANGE', start: e[0].start, end: l.end}
			if (((u.feature = r.value), e.length >= 7)) {
				const r = e[t + 1],
					n = e[t + 2]
				if ('delim' !== r.type) return {errid: 'INVALID_RANGE', start: e[0].start, end: l.end}
				{
					const i = r.value
					if (60 === i)
						'delim' !== n.type || 61 !== n.value || n.hasSpaceBefore
							? (u.rightOp = '<')
							: (u.rightOp = '<=')
					else {
						if (62 !== i) return {errid: 'INVALID_RANGE', start: e[0].start, end: l.end}
						'delim' !== n.type || 61 !== n.value || n.hasSpaceBefore
							? (u.rightOp = '>')
							: (u.rightOp = '>=')
					}
					const a =
							t +
							1 +
							(null !== (o = null === (s = u.rightOp) || void 0 === s ? void 0 : s.length) &&
							void 0 !== o
								? o
								: 0),
						d = e.at(a)
					if (a + 2 !== e.length) return {errid: 'INVALID_RANGE', start: e[0].start, end: l.end}
					u.rightToken = d
				}
			} else if (t + 2 !== e.length) return {errid: 'INVALID_RANGE', start: e[0].start, end: l.end}
		} else u.rightToken = r
		let n
		const {leftToken: i, leftOp: f, feature: c, rightOp: y, rightToken: h} = u
		let E, v
		if (void 0 !== i)
			if ('ident' === i.type) {
				const {type: e, value: t} = i
				'infinite' === t && (E = {type: e, value: t})
			} else if ('number' === i.type || 'dimension' === i.type || 'ratio' === i.type) {
				const {hasSpaceBefore: e, hasSpaceAfter: t, start: r, end: n, ...a} = i
				E = a
			}
		if (void 0 !== h)
			if ('ident' === h.type) {
				const {type: e, value: t} = h
				'infinite' === t && (v = {type: e, value: t})
			} else if ('number' === h.type || 'dimension' === h.type || 'ratio' === h.type) {
				const {hasSpaceBefore: e, hasSpaceAfter: t, start: r, end: n, ...i} = h
				v = i
			}
		if (void 0 !== E && void 0 !== v)
			if (('<' !== f && '<=' !== f) || ('<' !== y && '<=' !== y)) {
				if (('>' !== f && '>=' !== f) || ('>' !== y && '>=' !== y))
					return {errid: 'INVALID_RANGE', start: e[0].start, end: l.end}
				n = {leftToken: E, leftOp: f, feature: c, rightOp: y, rightToken: v}
			} else n = {leftToken: E, leftOp: f, feature: c, rightOp: y, rightToken: v}
		else
			((void 0 === E && void 0 === f && void 0 !== y && void 0 !== v) ||
				(void 0 !== E && void 0 !== f && void 0 === y && void 0 === v)) &&
				(n = {leftToken: E, leftOp: f, feature: c, rightOp: y, rightToken: v})
		return null != n ? n : {errid: 'INVALID_RANGE', start: e[0].start, end: l.end}
	}
	return {errid: 'INVALID_RANGE', start: e[0].start, end: l.end}
}
